import React, { useState, useEffect } from 'react';
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import { useWallet } from 'WalletProvider';
import axios from 'axios';

const MergeBadge = () => {
  const [isAnimating, setIsAnimating] = useState(false);
    const { wallet, selectedChain } = useWallet();

    const [points, setPoints] = useState(0);

    useEffect(() => {
      const fetchUserPoints = async () => {
        try {
          const response = await axios.get(`https://rafiki-launchpad.devligence.com/points/user/${wallet?.address}/`);
          if (response.data.success) {
            setPoints(response.data.data.totalPoints);
          }
        } catch (error) {
          console.error("Error fetching user points", error);
        }
      };
  
      fetchUserPoints();
    }, [wallet]);
  
  // Animation effect when points change
  useEffect(() => {
    setIsAnimating(true);
    const timer = setTimeout(() => setIsAnimating(false), 700);
    return () => clearTimeout(timer);
  }, [points]);

  return (
    <VuiBox
      display="flex"
      alignItems="center"
      bgColor="dark"
      borderRadius="xl"
      px={2.5}
      py={1.2}
      maxWidth="xs"
      sx={{ 
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.4)',
        position: 'relative',
        overflow: 'hidden',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '2px',
          background: 'linear-gradient(90deg, #ff6b6b, #ffb347, #7159c1)',
        }
      }}
    >
      {/* Points Display with Animation */}
      <VuiTypography 
        variant="h5" 
        color="white" 
        fontWeight="bold"
        mr={2}
        sx={{
          transition: 'transform 0.3s ease, opacity 0.3s ease',
          transform: isAnimating ? 'scale(1.2)' : 'scale(1)',
          opacity: isAnimating ? 0.8 : 1,
          textShadow: '0 0 10px rgba(255, 107, 107, 0.7)'
        }}
      >
        {points}
      </VuiTypography>
      
      {/* MF Badge with Glow Effect */}
      <VuiBox
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="26px"
        height="26px"
        borderRadius="xl"
        ml="auto"
        sx={{ 
          background: 'linear-gradient(135deg, #ff6b6b, #7159c1)',
          boxShadow: '0 0 15px rgba(113, 89, 193, 0.6)',
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            inset: '1px',
            borderRadius: 'inherit',
            background: 'linear-gradient(135deg, rgba(255, 107, 107, 0.9), rgba(113, 89, 193, 0.9))',
          }
        }}
      >
        <VuiTypography 
          variant="button" 
          color="white" 
          fontWeight="bold"
          sx={{ 
            position: 'relative', 
            zIndex: 2,
            letterSpacing: '0.5px',
            textShadow: '0 0 4px rgba(255, 255, 255, 0.5)'
          }}
        >
          MF
        </VuiTypography>
      </VuiBox>
    </VuiBox>
  );
};

export default MergeBadge;